import { useRef } from 'react';
import PropTypes from 'prop-types';
import { Grid, Dialog, Container, Stack, Button, Box } from '@mui/material';
import BulkReminderForm from './BulkReminderForm';
import Iconify from '../Iconify';
import { Transition } from '.';
import { useSelector } from '../../redux/store';
import { getSelectedLeadIdsForApi } from '../../utils/selectionModel';
import {
    reminderDialogStyle,
    reminderStackStyle,
    reminderFooterStyle,
    cancelButtonStyle,
    saveButtonStyle
} from '../../styles/AddReminderPopup';

const bulkReminderDialogStyle = {
    ...reminderDialogStyle,
    ' .MuiDialog-container': { width: '600px', height: 'auto', maxHeight: '90vh', maxWidth: '95vw' },
};

const BulkReminderPopup = ({ open, onClose }) => {
    const inputRef = useRef();
    const { multiLead } = useSelector((state) => state.lead);
    const leadCount = getSelectedLeadIdsForApi(multiLead).length;

    const handleNext = () => {
        inputRef.current.submit();
    };

    return (
        <Dialog
            TransitionComponent={Transition}
            open={open}
            onClose={onClose}
            sx={bulkReminderDialogStyle}
        >
            <Stack sx={reminderStackStyle}>
                <Grid container spacing={1} sx={{ margin: 'auto', width: '100%' }}>
                    <Container
                        maxWidth="xl"
                        sx={{ padding: '0 !important' }}
                    >
                        <BulkReminderForm ref={inputRef} onClose={onClose} />
                    </Container>
                </Grid>
            </Stack>
            <Box sx={reminderFooterStyle}>
                <Button
                    color="inherit"
                    sx={cancelButtonStyle}
                    onClick={() => onClose()}
                >
                    Cancel
                </Button>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={handleNext}
                    disabled={leadCount === 0 || leadCount > 50}
                    startIcon={<Iconify icon="mdi:bell-plus" />}
                    sx={{
                        ...saveButtonStyle,
                        bgcolor: '#00A76F',
                        '&:hover': { bgcolor: '#007B55' },
                    }}
                >
                    {`Create Reminders (${leadCount})`}
                </Button>
            </Box>
        </Dialog>
    );
};

export default BulkReminderPopup;

BulkReminderPopup.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
};
